import { ReturnIntegrationProviderSchema } from "@redotech/redo-model/return-integration-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const integrationSummarySchema = z.object({
  integration: ReturnIntegrationProviderSchema,
  staleCount: z.number().int().min(0),
  processedCount: z.number().int().min(0),
  accountCount: z.number().int().min(0),
});

export type IntegrationSummary = z.infer<typeof integrationSummarySchema>;

export const getReturnIntegrationMetricsSummary = unaryRpc({
  name: "getReturnIntegrationMetricsSummary" as const,
  input: z.object({
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    integrations: z.array(ReturnIntegrationProviderSchema).optional(),
    teamId: z.string().optional(),
  }),
  output: z.object({
    totalStaleReturns: z.number().int().min(0),
    totalAutomationProcessed: z.number().int().min(0),
    activeIntegrationsCount: z.number().int().min(0),
    affectedAccountsCount: z.number().int().min(0),
    byIntegration: z.array(integrationSummarySchema),
  }),
});

export type GetReturnIntegrationMetricsSummaryInput = z.infer<
  typeof getReturnIntegrationMetricsSummary.input
>;
export type GetReturnIntegrationMetricsSummaryOutput = z.infer<
  typeof getReturnIntegrationMetricsSummary.output
>;
